import React from 'react';
import '../../styles/Hero/Hero.css';
import Afrogotech from '../../assets/logo.png';
// import Languages from './Languages';
import { useTranslation } from 'react-i18next';
import { Link } from "react-router-dom";
export default function Header(props) {
  const {solutionRef,activiesRef,aboutRef} = props
  const {t} = useTranslation();

  const handleScrollToSolution = () => {
    if (solutionRef.current) {
      solutionRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleScrollToActivies = () => {
    if (activiesRef.current) {
      activiesRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const handleScrollToAbout = () => {
    if (aboutRef.current) {
      aboutRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  
  return (
    <header>
        <nav className='navbar'>
          <a href='/'>
            <img src={Afrogotech} alt="Afrogotech" width={250} className='mainLogo'/>
          </a>
         <ul>
                <li><Link to="/">{t('Hero.Accueil')}</Link></li>
                <li onClick={handleScrollToAbout}>{t('Hero.A_propos')}</li>
                <li onClick={handleScrollToSolution}>{t('Hero.Solutions')}</li>
                <li onClick={handleScrollToActivies}>{t('Hero.Activités')}</li>
                <li><Link to="/contact-us">{t('Hero.Contact')}</Link></li>
                <li><Link to="/support">Support</Link></li>
                {/* <li>{<Languages/>}</li> */} 
                <li>
                  <a href='https://gps.afrogotech.ma/' target='_blank' rel="noreferrer">
                  <button class="cta">
                    <span>{t('Hero.Espace_client')}</span>
                    <svg viewBox="0 0 13 10" height="10px" width="15px">
                      <path d="M1,5 L11,5"></path>
                      <polyline points="8 1 12 5 8 9"></polyline>
                    </svg>
                  </button>
                  </a>
                  </li>
              </ul>
          </nav>
    </header>
  )
}
